const listeners = new Set();

export const subscribeConfirm = listener => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const confirm = options =>
  new Promise(resolve => {
    if (!listeners.size) {
      // Fallback nếu Provider chưa mount — vẫn dùng window.confirm để không vỡ flow
      const ok = window.confirm(
        [options?.title, options?.description].filter(Boolean).join('\n\n') ||
          'Bạn có chắc chắn?'
      );
      resolve(ok);
      return;
    }
    listeners.forEach(l => l({ options: options || {}, resolve }));
  });
